






























































import moment from 'moment'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import AListCustom from '../../../../../../../../components/AListCustom/AListCustom.vue'
import AListCustomItem from '../../../../../../../../components/AListCustom/AListCustomItem.vue'
import { RefBonusHistoryItem } from '../../../../../../includes/types/BonusHistory'
import ReceiveCashIcon from '../icons/ReceiveCashIcon.vue'

@Component({
  components: {
    AListCustomItem,
    AListCustom,
    ReceiveCashIcon,
  },
})
export default class ReferralCard extends Vue {
  @Prop() readonly invoice!: RefBonusHistoryItem

  private get reward(): string {
    return `${ this.invoice.reward }${ this.invoice.currency.symbol }`
  }

  get formattedDate() {
    return moment(this.invoice.invoice.invoice_date_time).format('LLL')
  }
}
